module.exports = __webpack_public_path__ + "../static/img/synapse_mini.de23797e.png";